import type { ICalendarItemDTO } from "../../../../../../api";

export enum BulkCalendarControlDateRange {
  Annual = 1,
  Quarter = 3,
  Month = 4,
  Week = 7,
  Day = 5,
}

export interface IBulkCalendarControlState<T extends number | string | unknown = unknown> {
  lastCalendar: Partial<Record<BulkCalendarControlDateRange, T>>;
  items: Record<BulkCalendarControlDateRange, ICalendarItemDTO<T>[]>;
  from: Partial<Record<BulkCalendarControlDateRange, T>>;
  to: Partial<Record<BulkCalendarControlDateRange, T>>;
  countLastItem: Partial<Record<BulkCalendarControlDateRange, number | undefined>>;
  selectedRanges: BulkCalendarControlDateRange[];
  availableDateRanges: BulkCalendarControlDateRange[];
  latestAvailableValue: boolean;
  currentSavedSettingsId?: number;
  dataSourceId?: number;
  tab?: number;
}

export interface IBulkCalendarControlAction {
  type: string;
  payload: {
    dateRange?: BulkCalendarControlDateRange;
    value: unknown;
  };
}

export interface IBulkCalendarControlProps {
  dataSourceId: number;
  onChange?: (selection: (string | number)[]) => void;
  selection: (string | number)[];
  items: ICalendarItemDTO<string | number>[];
  availableDateRanges: BulkCalendarControlDateRange[];
  isBulkSubscribtion: boolean;
}
